{
  "close": "Close",
  "notifications": "{count, plural, one {# notification} other {# notifications}}."
}
